export const EmbedBuilderUrl: string = 'https://eb.nadeko.bot';
export const CommandsUrl: string = 'https://nadeko.bot/commands';
export const SuggestUrl: string = 'https://nadeko.bot/';
export const GitlabUrl: string = 'https://gitlab.com/kwoth/nadekobot';
export const PaypalUrl: string = 'https://paypal.me/Kwoth/5usd';
export const PatreonUrl: string = 'https://patreon.com/NadekoBot';

export const InviteUrl: string = 'https://invite.nadeko.bot';
export const DiscordServerUrl: string = 'https://discord.nadeko.bot';
export const MinerUrl: string = 'https://miner.nadeko.bot';